import React, { PureComponent } from 'react'
import numWords from 'num-words'
import data from '../../../data.json'
import { getPersistedResults, startsWithVowel } from '../../helpers'
import getClassNameFactory from '@wel-ui/utility-class-names'
import PropTypes from 'prop-types'
import './SolutionBreadcrumb.css'
import ArrowLeftIcon from '@wel-ui/icons/lib/ui/arrow-left'
import { HeightExpand } from '../../animations'

export default class SolutionBreadcrumb extends PureComponent {
  data = data

  state = {
    chosenSteps: [],
  }

  displayName = 'SolutionBreadcrumb'

  static propTypes = {
    onBackClicked: PropTypes.func,
    useLocalStorage: PropTypes.bool,
    expanded: PropTypes.bool,
  }

  static defaultProps = {
    expanded: false,
  }

  static getDerivedStateFromProps(nextProps, state) {
    return {
      ...state,
      chosenSteps: nextProps.chosenSteps || state.chosenSteps || [],
    }
  }

  constructor(props, ...args) {
    super(props, ...args)

    this.getClassName = getClassNameFactory(this.displayName)

    if (props.useLocalStorage) {
      this.state = {
        ...this.state,
        ...this.configureStateFromLocalStorage(),
      }
    }
  }

  configureStateFromLocalStorage = () => {
    const persistedResults = getPersistedResults() || []

    if (persistedResults.length > 0) {
      // If the current URL differs from the expected URL, don't render.

      const lastStep = data.steps[persistedResults[persistedResults.length - 1]]

      const expectedUrl = lastStep.resultsUrl || null

      // In development, /edgeToEdge/CecTrtaSolutionBreadcrumb.html is a valid URL
      if (
        window.location.pathname === expectedUrl ||
        window.location.pathname ===
          '/edgeToEdge/CecTrtaSolutionBreadcrumb.html'
      ) {
        return {
          chosenSteps: persistedResults,
        }
      }
    }

    return {
      chosenSteps: [],
    }
  }

  render() {
    const { chosenSteps } = this.state
    const { onBackClicked } = this.props
    const { steps } = this.data

    const expanded = chosenSteps.length !== 0
    const numQuestions = Object.keys(steps).length
    let currentQuestion = 1
    if (typeof(chosenSteps[0]) !== "undefined") {
      currentQuestion = chosenSteps[0].charAt(1)
    }
    const stepOneLabel = (steps[chosenSteps[0]] || {}).label

    const BackElementType = onBackClicked ? 'button' : 'a'
    const backProps = {
      className: this.getClassName({ descendantName: 'backButton' }),
    }

    if (BackElementType === 'button') {
      backProps.onClick = onBackClicked
    } else {
      backProps.href = '/'
    }

    return (
      <HeightExpand
        className={this.getClassName()}
        pose={expanded ? 'expanded' : 'collapsed'}
        initialPose={
          this.props.expanded && chosenSteps.length > 0
            ? 'expanded'
            : 'collapsed'
        }>
        <div className={this.getClassName({ descendantName: 'inner' })}>
          <div className={this.getClassName({ descendantName: 'content' })}>
            <BackElementType {...backProps}>
              <ArrowLeftIcon width={20} height={20} />
            </BackElementType>

            {expanded && (
              <span className={this.getClassName({ descendantName: 'body' })}>
                Question <strong>{numWords(currentQuestion).toUpperCase()}</strong> of {numWords(numQuestions)}
                {chosenSteps.length > 1 && (
                  <span>
                    &nbsp;and am interested in&nbsp;
                    {chosenSteps.slice(1, chosenSteps.length).map(key => (
                      <strong key={key}>
                        {steps[key].label}
                        &nbsp;
                      </strong>
                    ))}
                  </span>
                )}
              </span>
            )}
          </div>
        </div>
      </HeightExpand>
    )
  }
}



// WEBPACK FOOTER //
// ./js/components/SolutionBreadcrumb/SolutionBreadcrumb.js